import styles from "./typo.module.scss";
export const Desc = ({
  text,
  autoWidth = false,
  fontSize = "12px",
  color = "#8a8a8a",
  fontWeight = "400",
  maxLine,
}: {
  text: string | React.ReactNode;
  autoWidth?: boolean;
  fontSize?: string;
  color?: string;
  fontWeight?: "400" | "700";
  maxLine?: number;
}) => {
  return (
    <span
      className={`${styles["desc"]} ${maxLine ? styles[`line-clamp-${maxLine}`] : ""}`}
      style={{
        width: autoWidth ? "auto" : "100%",
        color: color,
        fontSize: fontSize,
        fontWeight: fontWeight,
      }}
    >
      {text}
    </span>
  );
};
